import { ADD_ONS } from './profileAddOns';

export const primaryRoles = [
  'Player',
  'Scorer',
  'Umpire',
  'Coach',
  'Manager',
  'Match Referee',
];

export const battingStyles = ['Right-hand bat', 'Left-hand bat'];

export const bowlingStyles = [
  'Right-arm fast',
  'Right-arm medium',
  'Right-arm off spin',
  'Right-arm leg spin',
  'Left-arm fast',
  'Left-arm medium',
  'Left-arm orthodox spin',
  'Left-arm chinaman',
];

export const extraFeatureOptions = Object.values(ADD_ONS);
